import React, { useContext, useEffect, useState } from 'react';
import userAPI from '../services/API/user';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import {
  getFormattedMoneyString,
  getNumberFromMoneyString,
} from '../helpers/utils';
import shopAPI from '../services/API/shop';
import { NotificationManager } from '../components/common/react-notifications';

export const UserContext = React.createContext(null);

export const useUserContext = () => {
  return useContext(UserContext);
};

function useQuery() {
  return queryString.parse(useLocation().search);
}

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [shop, setShop] = useState({});
  const [usuallyWears, setUsuallyWears] = useState([]);
  const [braSize, setBraSize] = useState([]);
  const [heightData, setHeightData] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [wearOccassions, setWearOccassions] = useState([]);
  const [wearFrequencies, setWearFrequencies] = useState([]);
  const [availableFreeSlot, setAvailableFreeSlot] = useState(0);
  const [loadingUserDetails, setLoadingUserDetails] = useState(false);
  const { c, mrkt } = useQuery();

  useEffect(() => {
    let userId = c;
    let accept_marketing = mrkt;
    if (isNaN(parseInt(userId))) {
      let oldUserId = localStorage.getItem('userId');
      if (isNaN(parseInt(oldUserId))) {
        const testUserId = 340;
        oldUserId = testUserId;
      }
      userId = oldUserId;
    }

    localStorage.setItem('userId', userId);
    localStorage.setItem(
      'accept_marketing',
      accept_marketing ? accept_marketing : false
    );

    // let's load the user here
    setLoadingUserDetails(true);
    userAPI
      .getUserById(parseInt(userId))
      .then((data) => {
        data.id = parseInt(data.id);
        data.earningString = getFormattedMoneyString(data.earnings);
        data.earnings = getNumberFromMoneyString(data.earnings);
        return data;
      })
      .then(async (res) => {
        try {
          const shopData = await shopAPI.getShop();
          const braData = await userAPI.getUserBraSize();
          const heightDataList = await userAPI.getUserHeightList();
          const bodyTypeData = await userAPI.getUserBodyType();
          const usuallyWearsData = await userAPI.getUserUsuallyWears();
          const wearOccassionsData = await userAPI.getUserWearOccassions();
          const wearFrequenciesData = await userAPI.getUserWearFrequencies();
          const freeSlots = await userAPI.getFreeSlotCount({
            user_id: parseInt(userId),
          });
          setUser(res);
          setShop(shopData);
          setUsuallyWears(usuallyWearsData);
          setBraSize(braData);
          setHeightData(heightDataList);
          setBodyTypes(bodyTypeData);
          setWearOccassions(wearOccassionsData);
          setWearFrequencies(wearFrequenciesData);
          setAvailableFreeSlot(freeSlots.count || 0);
        } catch (e) {
          setUser(res);
        }
      })
      .catch((e) => {
        if (e?.message.toLowerCase().includes('network error')) {
          setUser({error: 'Network Error'});
          NotificationManager.error({
            message: 'There is no internet connection or server error!',
          });
        }
      })
      .finally(() => {
        setLoadingUserDetails(false);
      });
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        shop,
        setUser,
        loadingUserDetails,
        availableFreeSlot,
        usuallyWears,
        braSize,
        heightData,
        bodyTypes,
        wearOccassions,
        wearFrequencies,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
